<template>
  <div>

  <h2 style="display: inline;">{{$t('title.edit-mobile')}}</h2>

  <el-tabs v-model="currentTab">

    <el-tab-pane :label="$t('tab.details')">
      <el-row :gutter="40">

        <el-col :xs="24" :md="12" >

          <data-form
            model="mobiles"
            :entity="mobile"
            :fields="fields" />

        </el-col>

        <!-- TODO: Related mobile groups
        <el-col :span="12">

          <h4>{{ $t('related-mobiles') }}</h4>

          <data-table
            model="mobile-groups"
            :columns="['name', 'id']"
            :isSelected="isMobileGroupSelected"
            @selection-change="mobileGroupSelectChanged" />

        </el-col>
        -->

      </el-row>
    </el-tab-pane>

    <el-tab-pane :label="$t('tab.notifications')">
      <notification-settings :mobile="mobile"/>
    </el-tab-pane>

  </el-tabs>
  </div>

</template>

<script>
import NotificationSettings from 'components/notification-setting/NotificationSettings'

export default {
  name: 'mobile-details',
  data () {
    return {
      currentTab: 0,
      fields: {
        'contact_name': {
          rules: [{ max: 80 }]
        },
        'contact_phone': {
          rules: [{ max: 16 }]
        },
        'contact_email': {
          rules: [{type: 'email'}, { max: 254 }]
        },
        'contact_refid': {
          rules: [{ max: 80 }]
        },
        'show_distant_switches': {
          type: 'checkbox'
        }
      }
    }
  },
  computed: {
    mobile () {
      const id = this.$route.params.id

      return this.$store.getters['mobiles/findById'](id, this.$store.dispatch)
    }
  },
  components: {
    NotificationSettings
  }
}
</script>



// WEBPACK FOOTER //
// MobileDetails.vue?811d8344